import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IEmp } from '../../models/emp';
import { throwError } from '../helper';

/*
 * School
 */

export const getSchoolClassList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school/school-class?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const registerSchoolClass = (data: any) =>
  xapi.post(`/admin/v1/apis/school/school-class`, data).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

export const getSchoolList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school/schools?type=${data.type}&year=${data.year}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const deleteSchoolClass = (data: any) =>
  xapi.put('/admin/v1/apis/school/school-class', data).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

export const getSchoolGradeSchoolClassList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school/${data.schoolSeq}/school-grade/${data.schoolGrade}/school-class`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

/*
 * School-class
 */

export const getSchoolStatClassList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/class?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}&sortByGrade=${data.sortByGrade}&sortByClass=${data.sortByClass}&sortByMember=${data.sortByMember}&sortByFinish=${data.sortByFinish}&sortByAvg=${data.sortByAvg}&sortByTotal=${data.sortByTotal}&sortByWrite=${data.sortByWrite}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

/*
 * Rank
 */
export const getSchoolReadRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/rank/read?schoolSeq=${data.schoolSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolWalkRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/rank/walk?schoolSeq=${data.schoolSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolWriteRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/rank/write?schoolSeq=${data.schoolSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadSchoolRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/rank/${data.type}/download?schoolSeq=${data.schoolSeq}&month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'school_stat_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Statistics
 */

export const getSchoolMonthlyReadStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-stat/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWalkStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-stat/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWriteStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-stat/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyMemberList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-member?seq=${data.schoolSeq}&year=${data.year}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyReadMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-medal/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWalkMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-medal/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWriteMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-medal/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-stat/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-stat/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-stat/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-stat/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-stat/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-stat/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-data/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-data/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolMonthlyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/achievement-data/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-data/read?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-data/walk?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getSchoolDailyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/daily-achievement-data/write?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadSchoolMonthlyDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-stat/${data.type}/${data.dataType}/download?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'school_monthly_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadSchoolMonthlyMedalDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-medal/${data.type}/${data.dataType}/download?seq=${data.schoolSeq}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'school_monthly_medal.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadSchoolMonthlyMemberData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/monthly-member/download?seq=${data.schoolSeq}&year=${data.year}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'school_monthly_medal.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Log Manage
 */
export const getSchoolWriteList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/all-write-status?schoolSeq=${data.schoolSeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadSchoolWriteList = async (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/school-stat/all-write-status/download?schoolSeq=${data.schoolSeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'school_stat_log.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });
